import { useQuery } from 'react-query'
import { getChatList } from 'src/services/get/getChat'

export const useChannels = (userId, type = 'single_chat') => {
  return useQuery(['channels', userId, type], () => getChatList(userId, type))
}
